import { useId } from 'react';

/** The Cute Live mark (same artwork as public/favicon.svg). */
export function BrandMark({ size = 32, className }: { size?: number; className?: string }) {
  const id = useId();
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={id} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#14B8A6" />
          <stop offset="1" stopColor="#5EEAD4" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="18" fill="#012B2D" />
      <circle cx="32" cy="32" r="17" fill={`url(#${id})`} />
      <path d="M27.5 24.5v15l12-7.5z" fill="#00201F" />
    </svg>
  );
}
